module.exports = __webpack_public_path__ + "media/images/message_l-daf768b12501109cd7a8ee6331a19757.png";